import { render, staticRenderFns } from "./NotificationTypeSelector.vue?vue&type=template&id=3e872fca&scoped=true&"
import script from "./NotificationTypeSelector.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTypeSelector.vue?vue&type=style&index=0&id=3e872fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e872fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
